const COOKIE_NAME = "first_touch";
const MAX_AGE_SECONDS = 30 * 24 * 60 * 60;

/**
 * Records the very first visit on this device: external referrer + landing
 * page. First write wins, so later navigations (including the OAuth redirect
 * back from accounts.google.com) never overwrite the true acquisition source.
 *
 * A cookie rather than localStorage because the account is created on the
 * server, and that request — the /sign-up/email POST or the OAuth callback —
 * is the only moment both signup flows still have the acquisition browser on
 * the line. Email signups finish wherever the verification link opens, which
 * is usually the mail app's in-app browser with its own empty storage.
 * packages/auth/auth.ts reads this cookie and writes the fields onto the user.
 */
export function captureFirstTouch() {
	if (new RegExp(`(?:^|;\\s*)${COOKIE_NAME}=`).test(document.cookie)) {
		return;
	}

	let referrer = document.referrer;
	// Same-origin referrers are internal navigation, not a source.
	if (referrer.startsWith(window.location.origin)) {
		referrer = "";
	}

	const value = JSON.stringify({
		r: referrer.slice(0, 500),
		l: (window.location.pathname + window.location.search).slice(0, 500),
	});

	document.cookie = [
		`${COOKIE_NAME}=${encodeURIComponent(value)}`,
		"path=/",
		`max-age=${MAX_AGE_SECONDS}`,
		// Lax still rides along on the top-level OAuth redirect back from Google.
		"SameSite=Lax",
		...(window.location.protocol === "https:" ? ["Secure"] : []),
	].join("; ");
}
